export const messages = {
  redirect: "The access token is invalid/expired, will redirect you to login.",
  logout: "Triggering logout process.",
  success: "Triggering redirect to target application.",
  error: "There is an issue while login. Please close the browser tab and login again.",
};
